export default __webpack_public_path__ + "static/media/rule.e75d9c91.png";